// Workaround: Optimizely's modified jQuery UI datepicker comments out
// _hideDatepicker() after selection, keeping the calendar open but never
// re-rendering the HTML — so ui-state-active is never applied to the
// selected date. This event delegation manually toggles the class on click.
if (typeof document !== "undefined") {
  // Use capture phase to intercept before jQuery UI's handlers
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest(".ui-datepicker td a.ui-state-default");
    if (!link) return;

    const calendar = link.closest(".ui-datepicker-calendar");
    if (!calendar) return;

    calendar.querySelectorAll("a.ui-state-active").forEach((el) => {
      el.classList.remove("ui-state-active");
    });
    link.classList.add("ui-state-active");
  }, true);
}
